export const languages = [
    {
        id: 1,
        name: 'Java',
        level: 'Experienced'
    },
    {
        id: 2,
        name: 'Kotlin',
        level: 'Experienced'
    },
    {
        id: 3,
        name: 'JavaScript',
        level: 'Intermediate'
    },
    {
        id: 4,
        name: 'HTML',
        level: 'Intermediate'
    },
    {
        id: 5,
        name: 'CSS',
        level: 'Intermediate'
    },
    {
        id: 6,
        name: 'Dart',
        level: 'Intermediate'
    },
    {
        id: 7,
        name: 'Node JS',
        level: 'Basic'
    }
]

export const frameworks = [
    {
        id: 1,
        name: 'Android Development',
        level: 'Experienced'
    },
    {
        id: 2,
        name: 'Spring Boot',
        level: 'Intermediate'
    },
    {
        id: 3,
        name: 'React',
        level: 'Basic'
    },
    {
        id: 4,
        name: 'Git',
        level: 'Experienced'
    },
    {
        id: 5,
        name: 'MySQL',
        level: 'Intermediate'
    }
]